import Shop from '../shop';

export default class ShoeShop extends Shop {
    /**
     *
     */
    constructor() {
        super({
            name:                 'Shoe shop',
            id:                   'ShoeShop',
            coolDown:             30,
            faClass:              'fae-high-heel',
            individualCostFactor: 1.145,
            baseEarnings:         540.0,
            baseCosts:            720.0,
            grade:                3
        });
    }
}
